import { ClipboardList, FileStack, Receipt, PiggyBank, CalendarClock,
  ChevronRight } from "lucide-react";
import { money } from "../lib/api";

const TONE = {
  ok: "text-emerald-700", good: "text-emerald-700", warn: "text-amber-700",
  bad: "text-rose-700", none: "text-slate-400",
};
const DOT = {
  ok: "bg-emerald-500", good: "bg-emerald-500", warn: "bg-amber-500",
  bad: "bg-rose-500", none: "bg-slate-300",
};

const Tile = ({ icon: Icon, label, value, tone, title, extra, onClick, testId }) => (
  <button onClick={onClick} data-testid={testId} title={title}
          className="group flex flex-col gap-1.5 rounded-lg border border-slate-200 px-3 py-2.5 text-left transition-colors hover:border-slate-300 hover:bg-slate-50">
    <span className="flex items-center gap-1.5">
      <Icon className="h-3.5 w-3.5 shrink-0 text-slate-400" />
      <span className="truncate text-xs font-medium text-slate-500">{label}</span>
      <ChevronRight className="ml-auto h-3.5 w-3.5 shrink-0 text-slate-300 group-hover:text-slate-500" />
    </span>
    <span className="flex items-center gap-2">
      <span className={`h-1.5 w-1.5 shrink-0 rounded-full ${DOT[tone] || DOT.none}`} />
      <span className={`truncate text-xs font-medium ${TONE[tone] || TONE.none}`}>{value}</span>
    </span>
    {extra}
  </button>
);

/** Six tiles in one row, each one a door into the tab that owns it. */
export default function ProjectDashboard({ dashboard, health, onGo }) {
  if (!dashboard) return null;
  const d = dashboard;
  return (
    <div className="grid gap-2 sm:grid-cols-2 lg:grid-cols-5"
         data-testid="ops-project-dashboard">
      <Tile icon={ClipboardList} label="Submittals" value={d.submittals.line}
            tone={d.submittals.tone} testId="ops-dash-submittals"
            onClick={() => onGo("submittals")}
            extra={d.submittals.total > 0 && (
              <span className="h-1.5 w-full overflow-hidden rounded-full bg-slate-100">
                <span className="block h-full rounded-full bg-emerald-500"
                      style={{ width: `${d.submittals.pct}%` }} />
              </span>
            )} />
      <Tile icon={FileStack} label="Change Orders" value={d.change_orders.line}
            tone={d.change_orders.tone} testId="ops-dash-change-orders"
            onClick={() => onGo("change_orders")} />
      <Tile icon={Receipt} label="Invoices" value={d.invoices.line} tone={d.invoices.tone}
            testId="ops-dash-invoices" onClick={() => onGo("invoicing")}
            extra={health && (
              <span className="truncate text-[11px] text-slate-400">
                Billed {Math.round((health.billed_pct || 0) * 100)}% of the contract
              </span>
            )} />
      <Tile icon={PiggyBank} label="Budget" value={d.budget.line} tone={d.budget.tone}
            title={d.budget.math} testId="ops-dash-budget" onClick={() => onGo("budget")}
            extra={health && (
              <span className="truncate text-[11px] text-slate-400">
                Spent {Math.round((health.spent_pct || 0) * 100)}% of the budget
                {health.gain_fade < 0 ? ` · fade ${money(Math.abs(health.gain_fade))}` : ""}
                {health.gain_fade > 0 ? ` · gain ${money(health.gain_fade)}` : ""}
              </span>
            )} />
      <Tile icon={CalendarClock} label="Job Slide" value={d.slide.line} tone={d.slide.tone}
            testId="ops-dash-slide" onClick={() => onGo("info")}
            extra={d.slide.contract_start && (
              <span className="truncate text-[11px] text-slate-400">
                contract {d.slide.contract_start}
                {d.slide.project_start ? ` · field ${d.slide.project_start}` : ""}
              </span>
            )} />
    </div>
  );
}
